import Empty from 'icons/lib/Empty.svg';
import { Trans } from 'react-i18next';

import { useTranslation } from '@/i18n/client';
import { useProductList } from '@/modules/product/context/productList';

import styles from './EmptyList.module.scss';

export const EmptyList = () => {
  const { t } = useTranslation(['products']);
  const { query, categorySlug } = useProductList();

  return (
    <div className={styles.emptyList}>
      <Empty />
      <h2 className={styles['emptyList--title']}>
        {categorySlug === 'search' ? (
          <Trans
            i18nKey="productList.searchNotFound"
            t={t}
            components={[<span key={0} />]}
            values={{ query }}
          />
        ) : (
          t('productList.noProducts')
        )}
      </h2>

      {categorySlug === 'search' && (
        <div className={styles['emptyList--tryAgain']}>
          <p>{t('productList.searchTryAgain')}</p>
          <ul>
            <li>{t('productList.typeAnotherName')}</li>
            <li>{t('productList.checkForMistakes')}</li>
            <li>{t('productList.searchForSomethingElse')}</li>
          </ul>
        </div>
      )}
    </div>
  );
};
